import { computed, ref } from 'vue'

import type { Order, OrdersQueryParams } from '@/api/functions/orders/orders.action'

import { getOrdersAction } from '@/api/functions/orders/orders.action'

import { useQueryApi } from './useApi'

export function useOrders(initialFilters: OrdersQueryParams = {}) {
  const currentPage = ref(initialFilters.page || 1)

  const activeFilters = ref<OrdersQueryParams>({
    ...initialFilters,
  })

  const query = useQueryApi({
    queryKey: computed(() => [
      'orders',
      {
        ...activeFilters.value,
        page: currentPage.value,
      },
    ]),

    queryFn: () =>
      getOrdersAction({
        ...activeFilters.value,
        page: currentPage.value,
      }),

    staleTime: 1000 * 60,
  })

  const orders = computed<Order[]>(() => query.data.value?.data || [])

  const pagination = computed(() => query.data.value?.pagination)

  const goToPage = (page: number) => {
    currentPage.value = page
  }

  const updateFilters = (newFilters: OrdersQueryParams) => {
    const cleanFilters = Object.fromEntries(
      Object.entries(newFilters).filter(([, value]) => value !== '' && value !== null && value !== undefined)
    ) as OrdersQueryParams

    activeFilters.value = {
      ...cleanFilters,
    }

    currentPage.value = 1
  }

  return {
    orders,
    pagination,
    currentPage,
    activeFilters,
    goToPage,
    updateFilters,
    ...query,
  }
}
